import { createGlobalStyle } from 'styled-components'

/**
 * Estilos cuando el navegador aplica autofill (-webkit-autofill).
 * No habilita autofill: solo define fondo/texto verde si el usuario lo fuerza.
 * Requiere data-auth-autofill en el contenedor (AuthModalBody enableAutofillStyles).
 */
export const AuthAutofillStyles = createGlobalStyle`
  [data-auth-autofill] input:-webkit-autofill,
  [data-auth-autofill] input:-webkit-autofill:hover,
  [data-auth-autofill] input:-webkit-autofill:focus,
  [data-auth-autofill] input:-webkit-autofill:active,
  [data-auth-autofill] input:autofill,
  [data-auth-autofill] input:autofill:hover,
  [data-auth-autofill] input:autofill:focus,
  [data-auth-autofill] input:autofill:active {
    -webkit-text-fill-color: #b8e66e !important;
    color: #b8e66e !important;
    caret-color: #b8e66e; 
    border-radius: 0.2em;
    padding: 0  0.3em;
    -webkit-box-shadow: 0 0 0 1000px #111d03 inset !important;
    box-shadow: 0 0 0 1000px #111d03 inset !important;
    background-color: #12470b57 !important;
    transition: background-color 99999s ease-out;
  }
`
